import TableComponent from "../sgb/TableComponent";
import ConfigComponent from "../ConfigComponent";
import React, {FC, useState} from "react";
import GatewayService from "../../service/GatewayService";
import {RadioComponent} from "../util/RadioComponent";
import FeedComponent from "../FeedComponent";
import LookSellExchange from "../sgb/LookSellExchange";
import ChartComponent from "../ChartComponent";
import ExchangeComponent from "../sgb/ExchangeComponent";
import HoldingComponent from "./HoldingComponent";


export const SGBReportComponent:FC = () => {
    const [type, setType] = useState(1);
        return <>
            <br/>
            <br/>
            <RadioComponent text="holding" actual={type} val={1} set={setType}/>&emsp;
            <RadioComponent text="feed" actual={type} val={2} set={setType}/>&emsp;
            <RadioComponent text="look sell exchange" actual={type} val={3} set={setType}/>&emsp;
            <RadioComponent text="chart" actual={type} val={4} set={setType}/>&emsp;
            <RadioComponent text="exchanges" actual={type} val={5} set={setType}/>&emsp;
            <br/>
            <br/>
            {type===1 ? <HoldingComponent/> : <></>}

        </>
}
